import * as React from 'react';

import { Button, Typography } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

import { ChangeHistoryModal } from './ChangeHistoryModal';

type ProductData = {
  id: number;
  title: string;
};

type ProductChangeHistoryProps = {
  productData: ProductData;
};

export const ProductChangeHistory = ({ productData }: ProductChangeHistoryProps) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <>
      <Button
        id='quickview-change-history'
        type='text'
        block
        onClick={() => setIsModalOpen(true)}
        className='flex h-12.5 items-center justify-between gap-2 border border-(--uizz-antd-color-border-secondary) px-4 py-3 text-left hover:bg-(--uizz-antd-color-fill-tertiary)'
      >
        <span className='flex min-w-0 items-center gap-2'>
          <Icon.RotateCcw size={16} className='shrink-0 text-(--uizz-antd-color-text-secondary)' />
          <Typography.Text ellipsis>Histórico de alterações</Typography.Text>
        </span>
        <Icon.ChevronRight size={16} className='shrink-0 text-(--uizz-antd-color-text-secondary)' />
      </Button>
      <ChangeHistoryModal isOpen={isModalOpen} handleClose={() => setIsModalOpen(false)} productData={productData} />
    </>
  );
};
